import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsApachecassandraComponent } from './simple-icons-apachecassandra.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsApachecassandraComponent ],
    exports:      [ SimpleIconsApachecassandraComponent ],
    bootstrap:    []
})
export class SimpleIconsApachecassandraModule {}
